<template>
    <MiniBetSlip
        v-bind:class="`${gaClassPrefix}_Expand`"
        v-bind:title="headerTitleDisplay"
        v-bind:count="headerTicketCount"
        v-bind:odds="headerOddsDisplay"
        v-bind:maxPayout="headerMaxPayoutDisplay"
        v-bind:hasWarning="shouldShowParlaySelectionWarning"
        v-on:click="expandBetSlip"
    />
</template>

<script setup lang="ts">
    import { storeToRefs } from 'pinia';
    import { computed } from 'vue';
    import MiniBetSlip from '@/components/betSlip/MiniBetSlip.vue';
    import { BetSlipState, SingleModeBetSlipTab } from '@/interface/enum';
    import { getBetSlipGaClassPrefix } from '@/libraries/betSlip/betSlipGaClass';
    import { useParlayInSingleCta } from '@/libraries/composables/useParlayInSingleCta';
    import { i18n } from '@/libraries/i18n';
    import { useBetSlipStore } from '@/stores/betSlip/betSlipStore';
    import { useSingleModeBetSlipStore } from '@/stores/betSlip/singleModeBetSlipStore';

    const {
        activeTab,
        betSlipTitle,
        headerTicketCount,
        headerOddsDisplay,
        headerMaxPayoutDisplay,
        shouldShowParlaySelectionWarning,
    } = storeToRefs(useSingleModeBetSlipStore());
    const { setBetSlipState } = useBetSlipStore();
    const { parlayFooterErrorMessage } = useParlayInSingleCta();

    const gaClassPrefix = computed(() => getBetSlipGaClassPrefix('Mini', activeTab.value));
    const headerTitleDisplay = computed(() => (
        activeTab.value === SingleModeBetSlipTab.Parlay
        && parlayFooterErrorMessage.value !== null
            ? i18n.t('bottom_function_bet_slip')
            : betSlipTitle.value
    ));

    function expandBetSlip() {
        setBetSlipState(BetSlipState.Medium);
    }
</script>
